import React, { useEffect } from "react";
import { CustomModal } from "@/components/Modal";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { CAutocompleteMultiFreeSoloTextField } from "@/components/TextField/CAutocompleteMultiFreeSoloTextField";
import { SizingWrapperStyle } from "@/components/Wrapper";
import { convertTypeEnglishToJapanese } from "../utils";

interface TagFormData {
  tags: string[];
}

interface TagDetailModalProps {
  open: boolean;
  onClose: () => void;
  rowData: {
    id: number;
    bookType: string;
    location: string;
    chibanKaokuNumber: string;
    tags?: string[];
  } | null;
  onSave: (id: number, tags: string[]) => void;
}

export const TagDetailModal: React.FC<TagDetailModalProps> = ({
  open,
  onClose,
  rowData,
  onSave,
}) => {
  const { control, getValues, reset, handleSubmit } = useForm<TagFormData>({
    defaultValues: {
      tags: [],
    },
  });

  useEffect(() => {
    if (rowData) {
      reset({ tags: rowData.tags ?? [] });
    }
  }, [rowData, reset]);

  const onSubmit = (data: TagFormData): void => {
    if (rowData) {
      onSave(rowData.id, data.tags);
      onClose();
    }
  };

  const handleClose = (
    _: Record<string, unknown>,
    reason: "backdropClick" | "escapeKeyDown"
  ): void => {
    if (reason === "backdropClick") {
      return;
    }
    onClose();
  };

  if (!rowData) {
    return null;
  }

  return (
    <CustomModal
      isOpen={open}
      handleClose={handleClose}
      ariaLabelledby="tag-detail-modal-title"
      ariaDescribedby="tag-detail-modal-description"
      width={600}
      overflow="auto"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          void handleSubmit(onSubmit)(e);
        }}
      >
        <Stack spacing={3}>
          <Typography id="tag-detail-modal-title" variant="h5" component="h2">
            タグ詳細
          </Typography>

          <Box>
            <Typography variant="body2" color="text.secondary">
              種別: {convertTypeEnglishToJapanese(rowData.bookType)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              所在: {rowData.location}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              地番/家屋番号: {rowData.chibanKaokuNumber}
            </Typography>
          </Box>

          <CAutocompleteMultiFreeSoloTextField
            control={control}
            name="tags"
            label="タグ"
            size={SizingWrapperStyle.LARGE}
            maxLength={20}
          />

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="outlined" onClick={onClose} size="large">
              キャンセル
            </Button>
            <Button variant="contained" type="submit" size="large">
              保存
            </Button>
          </Stack>
        </Stack>
      </form>
    </CustomModal>
  );
};
